'use client'
import {
  context_default
} from "./chunk-3EM7C2X3.mjs";

// src/context/favorites/useFavorites.ts
import { useContext } from "react";
function useFavorites() {
  const context = useContext(context_default);
  if (!context) {
    throw new Error("useFavorites must be used within a FavoritesProvider");
  }
  return context;
}

export {
  useFavorites
};
//# sourceMappingURL=chunk-BB4H5TUC.mjs.map